<div class="discord-claim">
  <div class="modal-header border-0">
    <h2 class="modal-title fui-heading-font t-24" id="modal-title">
      @if (state === "claimed" && claimWasSubscription) {
        {{ "discord_migration.claimed_title_sub" | translate }}
      } @else if (state === "claimed" && claimWasExtension) {
        {{ "discord_migration.claimed_title_owner" | translate }}
      } @else if (state === "claimed") {
        {{ "discord_migration.claimed_title" | translate }}
      } @else if (state === "unsupported_subscription") {
        {{ "discord_migration.unsupported_title" | translate }}
      } @else if (state === "needs_tmp") {
        {{ "discord_migration.needs_tmp_title" | translate }}
      } @else if (state === "offer_closed") {
        {{ "discord_migration.offer_closed_title" | translate }}
      } @else if (state === "not_linked") {
        {{ "discord_migration.link_heading" | translate }}
      } @else if (state === "not_signed_in") {
        {{ "discord_migration.welcome_title" | translate }}
      } @else if (state === "claim") {
        {{ "discord_migration.claim_title" | translate }}
      } @else {
        <!-- loading / error: nothing is known yet, so the title says where they are rather
             than claiming an outcome. "You're all set" used to land here via the fallback,
             announcing success before the status call had even returned. -->
        {{ "discord_migration.welcome_title" | translate }}
      }
    </h2>
    <button class="close" aria-label="Close" (click)="close()"><span aria-hidden="true">&times;</span></button>
  </div>

  <div class="modal-body">
    <!-- Only on a cold entry ("Here from Discord?"). Someone who reached this at the end of
         the linking flow has already read it. -->
    @if (showMigrationIntro && state !== "loading") {
      <p class="m-b-15">{{ "discord_migration.welcome_intro" | translate }}</p>
      <p class="m-b-20">{{ "discord_migration.welcome_attribution" | translate }}</p>
    }

    @if (state === "loading") {
      <myp-inline-loader [loading]="true" height="160px" spinnerName="discordClaim"></myp-inline-loader>
    }

    @if (state === "error") {
      <p class="m-b-15">{{ "discord_migration.load_error" | translate }}</p>
      <button class="btn btn-primary" (click)="load()">{{ "discord_migration.retry" | translate }}</button>
    }

    @if (state === "not_signed_in") {
      <div class="migration-cta text-center p-20">
        <p class="m-b-15">{{ "discord_migration.signed_out_prompt" | translate }}</p>
        <button class="btn btn-primary" (click)="signIn()">{{ "discord_migration.log_in_or_create" | translate }}</button>
      </div>
    }

    @if (state !== "loading" && state !== "error" && state !== "not_signed_in") {
      <!-- What the outstanding requirement is FOR. Without this the checklist is just unexplained
           ticks — the offer is the only reason to do either of them, so it leads. Dropped once
           both are met: see `_applyExplainerVisibility`. -->
      @if (showOfferExplainer) {
        <h3 class="t-18 bold m-b-5">
          @if (benefitIsSubscription) {
            {{ "discord_migration.offer_heading_sub" | translate }}
          } @else if (benefitIsExtension) {
            {{ "discord_migration.offer_heading_owner" | translate }}
          } @else {
            {{ "discord_migration.offer_heading_new" | translate }}
          }
        </h3>
        <p class="m-b-15">
          @if (benefitIsSubscription) {
            {{ "discord_migration.offer_why_sub" | translate }}
          } @else if (benefitIsExtension) {
            {{ "discord_migration.offer_why_owner" | translate }}
          } @else {
            {{ "discord_migration.offer_why_new" | translate }}
          }
        </p>
      }

      <!-- The checklist: the requirements, which are met, and what each one actually does. Shown
           while the member can still act on them; once claimed they are history and the payoff
           gets the space instead. -->
      @if (state !== "claimed") {
        <div class="claim-checklist m-b-20">
          <div class="claim-requirement" [class.met]="linked">
            <fa-icon [icon]="linked ? 'check-circle' : 'circle'" class="m-r-10"></fa-icon>
            <div>
              <div>{{ "discord_migration.checklist_discord" | translate }}</div>
              <div class="claim-requirement-why">{{ "discord_migration.checklist_discord_why" | translate }}</div>
            </div>
          </div>
          @if (showTmpRequirement) {
            <div class="claim-requirement" [class.met]="hasToneMasterPro">
              <fa-icon [icon]="hasToneMasterPro ? 'check-circle' : 'circle'" class="m-r-10"></fa-icon>
              <div>
                <div>{{ "discord_migration.checklist_tmp" | translate }}</div>
                <div class="claim-requirement-why">{{ "discord_migration.checklist_tmp_why" | translate }}</div>
              </div>
            </div>
          }
        </div>
      }

      @if (state === "claim") {
        <!-- Timing, not just amount: a Stripe coupon lands on the NEXT invoice, so an annual
             subscriber eleven months out sees nothing change today. Saying "12 months added"
             there would be a promise we do not keep. -->
        @if (benefitIsSubscription && benefitStartsAtRenewal) {
          <p class="m-b-20">{{ "discord_migration.claim_intro_sub_renewal" | translate }}</p>
        } @else if (benefitIsSubscription) {
          <p class="m-b-20">{{ "discord_migration.claim_intro_sub_now" | translate }}</p>
        } @else if (benefitIsExtension) {
          <p class="m-b-20">{{ "discord_migration.claim_intro_owner" | translate }}</p>
        } @else if (benefitUnknown) {
          <p class="m-b-20">{{ "discord_migration.claim_intro_generic" | translate }}</p>
        } @else {
          <p class="m-b-20">{{ "discord_migration.claim_intro_new" | translate }}</p>
        }
        <button class="btn btn-primary" [disabled]="working" (click)="claim()">
          @if (working) {
            {{ "discord_migration.claiming" | translate }}
          } @else if (benefitIsSubscription) {
            {{ "discord_migration.claim_button_sub" | translate }}
          } @else if (benefitIsExtension) {
            {{ "discord_migration.claim_button_owner" | translate }}
          } @else if (benefitUnknown) {
            {{ "discord_migration.claim_button_generic" | translate }}
          } @else {
            {{ "discord_migration.claim_button_new" | translate }}
          }
        </button>
      }

      @if (state === "needs_tmp") {
        <p class="m-b-20">{{ "discord_migration.needs_tmp_detail" | translate }}</p>
        <button class="btn btn-primary" (click)="registerToneMasterPro()">{{ "discord_migration.needs_tmp_button" | translate }}</button>
      }

      <!-- The payoff. Centred on the artwork rather than continuing the left-aligned checklist
           layout above: nothing is outstanding any more, so this reads as a result, not a step. -->
      @if (state === "claimed") {
        <div class="claimed-panel">
          <div class="claimed-art">
            <img [src]="claimWasSubscription ? './assets/images/fsp8-images/fsp-subscription-box.png' : './assets/images/fsp8-images/fsp8-box.png'" alt="" aria-hidden="true" />
          </div>
          @if (claimWasSubscription) {
            <fui-heading [text]="'discord_migration.claimed_heading_sub' | translate" level="2" fontSize="f7" textAlign="center"></fui-heading>
          } @else if (claimWasExtension) {
            <fui-heading [text]="'discord_migration.claimed_heading_owner' | translate" level="2" fontSize="f7" textAlign="center"></fui-heading>
          } @else {
            <fui-heading [text]="'discord_migration.claimed_heading_new' | translate" level="2" fontSize="f7" textAlign="center"></fui-heading>
          }
          @if (claimWasSubscription && claimStartsAtRenewal) {
            <p class="m-t-10 m-b-20">{{ "discord_migration.claimed_detail_sub_renewal" | translate }}</p>
          } @else if (claimWasSubscription) {
            <p class="m-t-10 m-b-20">{{ "discord_migration.claimed_detail_sub_now" | translate }}</p>
          } @else if (claimWasExtension) {
            <p class="m-t-10 m-b-20">{{ "discord_migration.claimed_detail_owner" | translate }}</p>
          } @else {
            <p class="m-t-10 m-b-20">{{ "discord_migration.claimed_detail_new" | translate }}</p>
          }
          <!-- Months, not software: there is nothing to download, so this goes to their plan. -->
          @if (claimWasSubscription) {
            <button class="btn btn-primary" (click)="viewSubscription()">{{ "discord_migration.view_subscription" | translate }}</button>
          } @else {
            <button class="btn btn-primary" (click)="viewProduct()">{{ "discord_migration.download_product" | translate }}</button>
          }
        </div>
      }

      <!-- A biller we cannot add time to (xchange and friends). The claim is NOT consumed, so
           this is "talk to us and come back", not a failure — and there is nothing to retry. -->
      @if (state === "unsupported_subscription") {
        <p class="m-b-20">
          @if (providerLabel) {
            {{ "discord_migration.unsupported_detail" | translate: { provider: providerLabel } }}
          } @else {
            {{ "discord_migration.unsupported_detail_generic" | translate }}
          }
        </p>
        <a class="btn btn-primary" href="https://support.fender.com" target="_blank" rel="noopener">{{ "discord_migration.unsupported_button" | translate }}</a>
      }

      @if (state === "offer_closed") {
        <p class="m-b-20">{{ "discord_migration.offer_closed_detail" | translate }}</p>
      }

      <!-- Not linked is an edge case here — this modal is reached after linking — but a member
           can land on the URL directly, so it offers the link panel rather than a dead end. -->
      @if (state === "not_linked") {
        <myp-account-connections [compact]="true" [returnTo]="returnTo"></myp-account-connections>
      }

      @if (errorMessage) {
        <div class="claim-error m-t-15" role="status">{{ errorMessage | translate }}</div>
      }
    }
  </div>

  <!-- No footer on the payoff: the one thing to do there is the download, and a second button
       beside it just competes with it. The header close is still there for anyone who wants out. -->
  @if (state !== "claimed") {
    <div class="modal-footer border-0">
      <button class="btn btn-blank" (click)="close()">{{ "discord_migration.explore_community" | translate }}</button>
    </div>
  }
</div>
